/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "EmvTag": {
            "values": {
              "UNKNOWN_EMV_TAG": 0,
              "ACQUIRER_IDENTIFIER": 40705,
              "ADDITIONAL_TERMINAL_CAPABILITIES": 40768,
              "AMEX_TRID": 40825,
              "AMOUNT_AUTHORISED_BINARY": 129,
              "AMOUNT_AUTHORISED_NUMERIC": 40706,
              "AMOUNT_OTHER_BINARY": 40708,
              "AMOUNT_OTHER_NUMERIC": 40707,
              "AMOUNT_REFERENCE_CURRENCY": 40762,
              "APPLICATION_CRYPTOGRAM": 40742,
              "APPLICATION_CURRENCY_CODE": 40770,
              "APPLICATION_CURRENCY_EXPONENT": 40772,
              "APPLICATION_DISCRETIONARY_DATA": 40709,
              "APPLICATION_EFFECTIVE_DATE": 24357,
              "APPLICATION_EXPIRATION_DATE": 24356,
              "APPLICATION_FILE_LOCATOR": 148,
              "APPLICATION_IDENTIFIER_CARD": 79,
              "APPLICATION_IDENTIFIER_TERMINAL": 40710,
              "APPLICATION_INTERCHANGE_PROFILE": 130,
              "APPLICATION_LABEL": 80,
              "APPLICATION_PREFERRED_NAME": 40722,
              "APPLICATION_PRIMARY_ACCOUNT_NUMBER": 90,
              "APPLICATION_PRIMARY_ACCOUNT_NUMBER_SEQUENCE_NUMBER": 24372,
              "APPLICATION_PRIORITY_INDICATOR": 135,
              "APPLICATION_PROGRAM_ID": 40794,
              "APPLICATION_REFERENCE_CURRENCY": 40763,
              "APPLICATION_REFERENCE_CURRENCY_EXPONENT": 40771,
              "APPLICATION_TEMPLATE": 97,
              "APPLICATION_TRANSACTION_COUNTER": 40758,
              "APPLICATION_USAGE_CONTROL": 40711,
              "APPLICATION_VERSION_NUMBER_1": 40712,
              "APPLICATION_VERSION_NUMBER_2": 40713,
              "AUTHORISATION_CODE": 137,
              "AUTHORISATION_RESPONSE_CODE": 138,
              "BANK_IDENTIFIER_CODE": 24404,
              "CANDIDATE_AID_LIST": 14647617,
              "CONTACTLESS_KERNEL_TYPE": 57136,
              "CARD_ERROR_INDICATION": 14647573,
              "CARD_PROCESSING_REQUIREMENTS": 40817,
              "CARD_RISK_MANAGEMENT_DATA_OBJECT_LIST_8C": 140,
              "CARD_RISK_MANAGEMENT_DATA_OBJECT_LIST_8D": 141,
              "CARD_TRANSACTION_QUALIFIERS": 40812,
              "CARDHOLDER_NAME": 24352,
              "CARDHOLDER_NAME_EXTENDED": 40715,
              "CARDHOLDER_VERIFICATION_METHOD_LIST": 142,
              "CARDHOLDER_VERIFICATION_METHOD_RESULTS": 40756,
              "CERTIFICATION_AUTHORITY_PUBLIC_KEY_INDEX_8F": 143,
              "CERTIFICATION_AUTHORITY_PUBLIC_KEY_INDEX_9F22": 40738,
              "COMMAND_TEMPLATE": 131,
              "CRYPTOGRAM_INFORMATION_DATA": 40743,
              "CUSTOMER_EXCLUSIVE_DATA": 40828,
              "DATA_AUTHENTICATION_CODE": 40773,
              "DEDICATED_FILE_NAME": 132,
              "DIRECTORY_DEFINITION_FILE_NAME": 157,
              "DIRECTORY_DISCRETIONARY_TEMPLATE": 115,
              "DYNAMIC_DATA_AUTHENTICATION_DATA_OBJECT_LIST": 40777,
              "EMV_PROPRIETARY_TEMPLATE": 112,
              "ENCIPHERED_PIN_DATA": 192,
              "FILE_CONTROL_INFORMATION_ISSUER_DISCRETIONARY_DATA": 48908,
              "FILE_CONTROL_INFORMATION_PROPRIETARY_TEMPLATE": 165,
              "FILE_CONTROL_INFORMATION_TEMPLATE": 111,
              "FINAL_AMOUNT_AUTHORISED_NUMERIC_QUICKCHIP": 14648666,
              "FORM_FACTOR_INDICATOR": 40814,
              "ICC_DYNAMIC_NUMBER": 40780,
              "INTEGRATED_CIRCUIT_CARD_PIN_ENCIPHERMENT_PUBLIC_KEY_CERTIFICATE": 40749,
              "INTEGRATED_CIRCUIT_CARD_PIN_ENCIPHERMENT_PUBLIC_KEY_EXPONENT": 40750,
              "INTEGRATED_CIRCUIT_CARD_PIN_ENCIPHERMENT_PUBLIC_KEY_REMAINDER": 40751,
              "INTEGRATED_CIRCUIT_CARD_PUBLIC_KEY_CERTIFICATE": 40774,
              "INTEGRATED_CIRCUIT_CARD_PUBLIC_KEY_EXPONENT": 40775,
              "INTEGRATED_CIRCUIT_CARD_PUBLIC_KEY_REMAINDER": 40776,
              "INTERAC_MERCHANT_TYPE_IND": 40792,
              "INTERAC_TTI": 40793,
              "INTERFACE_DEVICE_SERIAL_NUMBER": 40734,
              "INTERNATIONAL_BANK_ACCOUNT_NUMBER": 24403,
              "ISSUER_ACTION_CODE_DEFAULT": 40717,
              "ISSUER_ACTION_CODE_DENIAL": 40718,
              "ISSUER_ACTION_CODE_ONLINE": 40719,
              "ISSUER_APPLICATION_DATA": 40720,
              "ISSUER_AUTHENTICATION_DATA": 145,
              "ISSUER_CODE_TABLE_INDEX": 40721,
              "ISSUER_COUNTRY_CODE": 24360,
              "ISSUER_COUNTRY_CODE_ALPHA2_FORMAT": 24405,
              "ISSUER_COUNTRY_CODE_ALPHA3_FORMAT": 24406,
              "ISSUER_IDENTIFICATION_NUMBER": 66,
              "ISSUER_PUBLIC_KEY_CERTIFICATE": 144,
              "ISSUER_PUBLIC_KEY_EXPONENT": 40754,
              "ISSUER_PUBLIC_KEY_REMAINDER": 146,
              "ISSUER_SCRIPT_COMMAND": 134,
              "ISSUER_SCRIPT_IDENTIFIER": 40728,
              "ISSUER_SCRIPT_RESULTS": 40795,
              "ISSUER_SCRIPT_TEMPLATE_1": 113,
              "ISSUER_SCRIPT_TEMPLATE_2": 114,
              "ISSUER_URL": 24400,
              "JCB_CARDHOLDER_VERIFICATION_STATUS": 40784,
              "JCB_TERMINAL_INTERCHANGE_PROFILE": 40787,
              "KERNEL_ID_TERMINAL": 150,
              "LANGUAGE_PREFERENCE": 24365,
              "LAST_ONLINE_APPLICATION_TRANSACTION_COUNTER_REGISTER": 40723,
              "LOG_ENTRY": 40781,
              "LOG_FORMAT": 40783,
              "LOWER_CONSECUTIVE_OFFLINE_LIMIT": 40724,
              "MC_UNPREDICTABLE_NUMBER": 40810,
              "MC_VISA_TRID": 40729,
              "MERCHANT_CATEGORY_CODE": 40725,
              "MERCHANT_IDENTIFIER": 40726,
              "MERCHANT_NAME_AND_LOCATION": 40782,
              "MIURA_ICC_ATR": 99,
              "MIURA_ACQUIRER_INDEX": 194,
              "MIURA_STATUS_CODE": 195,
              "MIURA_STATUS_TEXT": 196,
              "MIURA_PIN_RETRY_COUNTER": 197,
              "MIURA_IDENTIFIER": 57101,
              "MIURA_VERSION": 57215,
              "MIURA_CONFIGURATION_INFORMATION": 237,
              "MIURA_SOFTWARE_INFORMATION": 239,
              "MIURA_MAGNETIC_TRACK1": 24353,
              "MIURA_MAGNETIC_TRACK2": 24354,
              "MIURA_MAGNETIC_TRACK3": 24355,
              "MIURA_PIN_DIGIT_STATUS": 14655745,
              "MIURA_PIN_ENTRY_STATUS": 14655746,
              "MIURA_TRM_STAGE": 913923,
              "MIURA_APPLICATON_SELECTION_REQUEST": 14656004,
              "MIURA_KEYBOARD_DATA": 14656005,
              "MIURA_SECURE_PROMPT_FILE_INDEXES": 14656006,
              "MIURA_NUMBER_FORMAT": 14656007,
              "MIURA_NUMERIC_DATA": 14656008,
              "MIURA_BATTERY_DATA": 14656009,
              "MIURA_GPO_STAGE": 14656010,
              "MIURA_OFFSET": 14656257,
              "MIURA_STREAM_SIZE": 14656258,
              "MIURA_TIMEOUT_VALUE": 14656259,
              "MIURA_MD5SUM": 14656260,
              "MIURA_CARDHOLDER_VERIFICATION_STATUS": 57128,
              "MIURA_P2PE_STATUS": 14659073,
              "MIURA_P2PE_DATA": 14659074,
              "MIURA_P2PE_KEY_SERIAL_NUMBER": 14659075,
              "MIURA_ONLINE_PINBLOCK": 14659076,
              "MIURA_ONLINE_PIN_KEY_SERIAL_NUMBER": 14659077,
              "MIURA_MAC": 14659078,
              "MIURA_MAC_RESULT": 14659079,
              "MIURA_MASKED_ICC_TRACK2_EQUIV": 14659159,
              "MIURA_MASKED_PAN": 14659162,
              "MIURA_MASKED_TRACK2": 14659106,
              "MIURA_MASKED_CONTACTLESS_TRACK2": 14659179,
              "MIURA_AMEX_MSD_CONTACTLESS_TRACK1": 14671681,
              "MIURA_AMEX_MSD_CONTACTLESS_TRACK2": 14671682,
              "MSR_APP_VER_READER": 40813,
              "PAYMENT_ACCOUNT_REFERENCE": 40740,
              "PERSONAL_IDENTIFICATION_NUMBER_TRY_COUNTER": 40727,
              "POINT_OF_SERVICE_ENTRY_MODE": 40761,
              "PROCESSING_OPTIONS_DATA_OBJECT_LIST": 40760,
              "PUNATC_TERMINAL_TRANSACTION_QUALIFIER": 40806,
              "PTAG_ISSUER_PIN_REQUEST": 14651137,
              "PTAG_ISSUER_SCA_CODE": 14651138,
              "PTAG_LIBPAYMENT_VERSION": 14649367,
              "PTAG_OUTCOME_STATUS_CODE": 14648673,
              "PTAG_PAN_LAST_FOUR": 14649362,
              "PTAG_READER_ERROR_CODE": 14648678,
              "PTAG_SPE_PAYMENT_FEATURE": 14648687,
              "PTAG_TRANSACTION_MODE": 14648850,
              "R12_TRACK_2_DATA": 14648642,
              "R12_ISSUER_SCRIPT_RESULT": 14648662,
              "RESPONSE_MESSAGE_TEMPLATE_FORMAT_1": 128,
              "RESPONSE_MESSAGE_TEMPLATE_FORMAT_2": 119,
              "SERVICE_CODE": 24368,
              "SHORT_FILE_IDENTIFIER": 136,
              "SIGNED_DYNAMIC_APPLICATION_DATA": 40779,
              "SIGNED_STATIC_APPLICATION_DATA": 147,
              "SPE_PAYMENT_METHOD": 14647608,
              "SPETAG_ICC_AID_LIST": 14647616,
              "STATIC_DATA_AUTHENTICATION_TAG_LIST": 40778,
              "STORAGE_DATA": 57151,
              "TERMINAL_ACCOUNT_TYPE": 24407,
              "TERMINAL_CAPABILITIES": 40755,
              "TERMINAL_COUNTRY_CODE": 40730,
              "TERMINAL_FLOOR_LIMIT": 40731,
              "TERMINAL_IDENTIFICATION": 40732,
              "TERMINAL_RISK_MANAGEMENT_DATA": 40733,
              "TERMINAL_TYPE": 40757,
              "TERMINAL_VERIFICATION_RESULTS": 149,
              "TRACK_1_DISCRETIONARY_DATA": 40735,
              "TRACK_1_DATA_CONTACTLESS": 86,
              "TRACK_2_DATA_CONTACTLESS": 40811,
              "TRACK_2_DISCRETIONARY_DATA": 40736,
              "TRACK_2_EQUIVALENT_DATA": 87,
              "TRANSACTION_CERTIFICATE_HASH_VALUE": 152,
              "TRANSACTION_CERTIFICATE_DATA_OBJECT_LIST": 151,
              "TRANSACTION_CURRENCY_CODE": 24362,
              "TRANSACTION_CURRENCY_EXPONENT": 24374,
              "TRANSACTION_DATE": 154,
              "TRANSACTION_FEATURE": 14648668,
              "TRANSACTION_PERSONAL_IDENTIFICATION_NUMBER_DATA": 153,
              "TRANSACTION_REFERENCE_CURRENCY_CODE": 40764,
              "TRANSACTION_REFERENCE_CURRENCY_EXPONENT": 40765,
              "TRANSACTION_SEQUENCE_COUNTER": 40769,
              "TRANSACTION_STATUS_INFORMATION": 155,
              "TRANSACTION_TIME": 40737,
              "TRANSACTION_TYPE": 156,
              "UNPREDICTABLE_NUMBER": 40759,
              "UPPER_CONSECUTIVE_OFFLINE_LIMIT": 40739,
              "VISA_TERM_ENTRY_CAPABILITY": 14648124,
              "APPLE_EFTPOS_MCR_INDICATOR": 57137
            }
          },
          "EmvTags": {
            "fields": {
              "entry": {
                "type": "squareup.common.EmvTags.Entry",
                "id": 1,
                "rule": "repeated"
              }
            },
            "nested": {
              "Entry": {
                "fields": {
                  "tag": {
                    "type": "squareup.common.EmvTag",
                    "id": 1,
                    "rule": "optional"
                  },
                  "value": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "CardholderVerificationMethodResults": {
            "fields": {
              "cardholderVerificationMethodPerformed": {
                "type": "squareup.common.CardholderVerificationMethodResults.CardholderVerificationMethod",
                "id": 1,
                "rule": "optional"
              },
              "cardholderVerificationMethodCondition": {
                "type": "squareup.common.CardholderVerificationMethodResults.CvmCondition",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "CardholderVerificationMethod": {
                "values": {
                  "DEFAULT_CVM_DO_NOT_USE": -1,
                  "FAIL_CVM_PROCESSING": 0,
                  "OFFLINE_PLAINTEXT_PIN": 1,
                  "ONLINE_ENCIPHERED_PIN": 2,
                  "ON_DEVICE_OR_OFFLINE_PLAINTEXT_PIN_AND_SIGNATURE": 3,
                  "OFFLINE_ENCIPHERED_PIN": 4,
                  "OFFLINE_ENCIPHERED_PIN_AND_SIGNATURE": 5,
                  "SIGNATURE": 30,
                  "NO_CVM": 31
                }
              },
              "CvmCondition": {
                "values": {
                  "DEFAULT_CONDITION_DO_NOT_USE": -1,
                  "UNKNOWN": 0,
                  "FAILURE": 1,
                  "SUCCESS": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.EmvTag && !$root.nested?.squareup?.nested?.common?.nested?.EmvTags && !$root.nested?.squareup?.nested?.common?.nested?.EmvTags?.nested?.Entry && !$root.nested?.squareup?.nested?.common?.nested?.CardholderVerificationMethodResults && !$root.nested?.squareup?.nested?.common?.nested?.CardholderVerificationMethodResults?.nested?.CardholderVerificationMethod && !$root.nested?.squareup?.nested?.common?.nested?.CardholderVerificationMethodResults?.nested?.CvmCondition) {
  $root.addJSON(jsonData);
}

/**
 * Server-side formatting for tags is done in
 * com.squareup.spif.formatting.EmvFieldFormatterFactory; when adding
 * new tags, make sure to add an entry there.
 *
 * SOURCE EmvTag @ squareup/common/emv.proto at 14:1
 */
export const EmvTag = $root.lookupEnum('squareup.common.EmvTag').values;
/**
 * SOURCE EmvTags @ squareup/common/emv.proto at 1129:1
 */
export const EmvTags = $root.lookupType('squareup.common.EmvTags');
fixType(EmvTags);
Builder.createAndAttachToType(EmvTags);
/**
 * SOURCE Entry @ squareup/common/emv.proto at 1130:3
 */
EmvTags.Entry = $root.lookupType('squareup.common.EmvTags.Entry');
fixType(EmvTags.Entry, {
  value: {
    required: true
  }
});
Builder.createAndAttachToType(EmvTags.Entry);
/**
 * SOURCE CardholderVerificationMethodResults @ squareup/common/emv.proto at 1137:1
 */
export const CardholderVerificationMethodResults = $root.lookupType('squareup.common.CardholderVerificationMethodResults');
fixType(CardholderVerificationMethodResults, {
  cardholderVerificationMethodPerformed: {
    required: true
  },
  cardholderVerificationMethodCondition: {
    required: true
  }
});
Builder.createAndAttachToType(CardholderVerificationMethodResults);
/**
 * EMVCo CVMs, as per EMVCo Spec v4.2. Enum values
 * are the 5-bit bitmask that identifies the CVM.
 *
 * SOURCE CardholderVerificationMethod @ squareup/common/emv.proto at 1142:3
 */
CardholderVerificationMethodResults.CardholderVerificationMethod = $root.lookupEnum('squareup.common.CardholderVerificationMethodResults.CardholderVerificationMethod').values;
/**
 * SOURCE CvmCondition @ squareup/common/emv.proto at 1160:3
 */
CardholderVerificationMethodResults.CvmCondition = $root.lookupEnum('squareup.common.CardholderVerificationMethodResults.CvmCondition').values;